module.exports = __webpack_public_path__ + "static/media/34.18bcd182.jpg";